module.exports = __webpack_public_path__ + "img/w3_button_check_white.3454948d.png";